var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-spinner"},[_c('div',{ref:"bar",staticClass:"load-spinner__bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }